import React from 'react'

const Shimmer = () => {
    return (<div className='flex flex-wrap'>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
            <div className='m-4 w-72 h-72 shadow-2xl bg-slate-200'></div>
    </div>
    )
}

export default Shimmer